export const FormDataScheduleCustodian = {
  id: null,
  custodian: null,
  aspect: null,
  action: null,
};

export const FormValidasiSchedule = {
  date: [(v) => !!String(v || "").trim() || "Tanggal harus diisi."],
  location: [(v) => !!String(v || "").trim() || "Tanggal harus diisi."],
  custodian: [(v) => !!String(v || "").trim() || "Kustodian harus diisi."],
  aspect: [(v) => !!String(v || "").trim() || "Aspek penilaian harus diisi."],
};
